module.exports = __webpack_public_path__ + "static/img/daren-but.f1c8b6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/1yuan365new/daren-but.png
// module id = mhKg
// module chunks = 0